// extracted by mini-css-extract-plugin
export default {"reportTable":"DashboardTable_reportTable__aj1U1","dashboardRight":"DashboardTable_dashboardRight__m7+X1","auditorDropdown":"DashboardTable_auditorDropdown__p8cYC"};